import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../AuthContext";

const LastPlayedTracks = () => {
    const { accessToken } = useContext(AuthContext);
    const [lastPlayedTracks, setLastPlayedTracks] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const fetchLastPlayedTracks = async () => {
        try {
            const response = await fetch("https://api.spotify.com/v1/me/player/recently-played?limit=5", {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            const data = await response.json();
            if (data && data.items) {
                setLastPlayedTracks(data.items.map(item => item.track));
            }
        } catch (error) {
            console.error("Error fetching last played tracks:", error);
        }
    };

    useEffect(() => {
        if (!accessToken) return;
        fetchLastPlayedTracks();
    }, [accessToken]);

    return (
        <div className="p-6 bg-gray-900 relative text-white rounded-xl shadow-lg inline-block w-full">
            <button 
                onClick={() => setIsOpen(!isOpen)} 
                className="w-full text-left text-lg font-semibold bg-gray-800 px-4 py-2 rounded-md flex justify-between items-center transition-all"
            >
                Son Çalınan Şarkılar
                <span className={`transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}>
                    ▼
                </span>
            </button>

            <div className={`overflow-hidden -ml-6 absolute z-50 p-6 rounded-xl overflow-y-auto bg-gray-900 transition-all duration-500 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
                style={{ width: "100%" }}>
                <ul className="mt-2 space-y-2">
                    {lastPlayedTracks.map((track, index) => (
                        <li key={index} className="flex items-center space-x-3 p-2 bg-gray-800 rounded-md shadow">
                            <img src={track.album.images[0].url} alt={track.name} className="w-10 h-10 rounded-md" />
                            <div className="w-full overflow-hidden">
                                <h3 className="text-sm font-medium">{track.name}</h3>
                                <h3 className="text-xs text-gray-400">{track.artists.map(artist => artist.name).join(", ")}</h3>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default LastPlayedTracks;
